import React from "react";
import { ControlLabel } from "react-bootstrap";

const RegistraionEmbedCode = ({ settings, eventKey }) => {
    function filterNullableValues(obj) {
        if (!obj) return {};

        return Object.entries(obj).reduce((acc, [key, value]) => {
            if (!value) return acc;

            if (
                typeof value === "object" &&
                !Array.isArray(value) &&
                value !== null
            ) {
                acc = { ...acc, [key]: filterNullableValues(value) };

                return acc;
            }

            acc[key] = value;

            return acc;
        }, {});
    }

    return settings ? (
        <>
            <ControlLabel>Код для встраивания</ControlLabel>
            <pre style={{ whiteSpace: "initial" }}>
                &lt;div id=&quot;widget-container&quot;&gt;&lt;/div&gt;
                <br />
                <br />
                &lt;script src="{location.origin}
                /widget/static/js/embed.js" &gt;&lt;/script&gt;
                <br />
                &lt;script&gt;
                <br />
                {`
                            createWidgetFrame(
                                document.querySelector("#widget-container"),
                                "${
                                    location.origin
                                }/widget/${eventKey}/registration",
                                ${JSON.stringify(
                                    filterNullableValues(settings),
                                    null,
                                    4
                                )}
                            );
                        `}
                <br />
                &lt;/script&gt;
            </pre>
        </>
    ) : (
        <></>
    );
};

export default RegistraionEmbedCode;
